module.exports = __webpack_public_path__ + "img/saar.9efbca13.png";